export default __webpack_public_path__ + "static/young-toddler2-b7a500622b20688a5ae463f566579373.jpg";